<template>
  <!-- <div class="test_box">
    页面颜色：
    <div style="width: 30px;height: 30px;" :style="{
        background:color
      }"></div>
    <div class="test_dialog">
      <my_color :color.sync="color"></my_color>
      <my_color :color.sync="color2" :pattern="pattern2" :linear_gradient="linear_gradient"></my_color>
    </div>
  </div> -->
  <!-- <draw_icon url="https://staticjs.71360.com/static/txys-001/image/icon_material/2068.png"></draw_icon> -->
  
  <div>
    <embed id="embed" src="/static/image/1.svg" type="image/svg+xml" width="300" height="300">
    <!-- <ul class="btns">
      <li v-for="(item,i) in btns" :style="{
        background:item
      }"></li>
    </ul> -->
    <span v-for="(item,i) in btns">
      <my_color :color.sync="item.color" title=" " @change="color_change"></my_color>
    </span>
    
    <div @click="upload">{{$t('components_my_img_selecter_img_selecter_2323')}}</div>
    <img :src="url" alt="">
  </div>
</template>

<script>
import i18n from '../language/index'

import {uploadyunfile} from '@/api/app.js'
  //import icons from "@/base/icon_config";


  export default {
    name: "test",
    data() {
      return {
        btns:[],
        url:'',
        select_class_name:'',
      }
    },
    components: {
      
    },
    methods:{
      select_btn(item,e){
        this.select_class_name = item.class_name;
      },
      get_color(){
        const path = $(document.getElementById('embed').getSVGDocument()).find('path');//获取每个图层
        console.log(111,path)
        var result = [];
        if(path.length > 0) {
          var path_color = $(path[0]).css('stroke');
          const color = this.color_filter(path_color);
          result.push(color)
        }
        // for(var i = 0; i < path.length; i++){
        //     var path_color = $(path[i]).css('fill');
        //     const class_name = $(path[i]).attr('class');
        //     const color = this.color_filter(path_color);
        //     let no_have = true; 

        //     for(var j = 0; j < result.length;j++){
        //       if(result[j].class_name === class_name){
        //         no_have = false;
        //         break;
        //       }
        //     }
        //     if(no_have){
        //       result.push({
        //         class_name,
        //         color
        //       });

        //     }
            
        // }
        this.btns = result;
      },

      color_change(e,i){
        const now_select = this.color_filter(e);//当前选中的颜色
        //遍历svg找相同的颜色
        var path = $(document.getElementById('embed').getSVGDocument()).find('path');
         for(var i = 0; i < path.length; i++){
              var one_color = this.color_filter($(path[i]).css('stroke'));
              //var path_class_path = $(path[i]).attr('class');
              console.log(one_color)
              $(path[i]).css('stroke',now_select);
              // if(path_class_path === this.select_class_name){
              //     $(path[i]).css('fill',now_select);

              // }
          }
      },

      //颜色处理，去空格去a
      color_filter(color){
        return color.replace(',1)',')').replace(', 1)',')').replace(/ /g,'').replace('rgba','rgb');
      },

      //svg转png
      svg_to_png(){

      },
      upload_test(){
        var content1 = ["This is my firt trip to an island"];
        var blob = new Blob(content1, { type: "text/plain" });
      },


      upload(){
        const svg_dom = $(document.getElementById('embed').getSVGDocument()).find('svg')[0]
        var svgString = new XMLSerializer().serializeToString(svg_dom);
        var svg = new Blob([svgString], {type: "image/svg+xml;charset=utf-8"});
        var img = new Image();
        var DOMURL = self.URL || self.webkitURL || self;
        var url = DOMURL.createObjectURL(svg);
        const that = this;
        
        img.src = url;
        img.onload = function () {
          var canvas = document.createElement('canvas')
          canvas.width = 300
          canvas.height = 300
          canvas.getContext('2d').drawImage(img, 0, 0, 300, 300)

          canvas.toBlob(blob => {
            const f = new File([blob], `${Date.now()}img.png`, {type: 'image/png', lastModified: Date.now()})
            let param = new FormData()
            param.append('file', f)
            param.append('folderId', 0)
            uploadyunfile(param).then(e => {
              if(e.code == 200 && e.data){
                that.url = e.data.filePath
              }
                    
            })
            
          })

        };
      }
    },
    mounted() {
      // 首次加载，等到首屏数据加载完毕，删除蒙层
      if ($('.init_mongolia_layer').length > 0) {
        $('.init_mongolia_layer').remove();
      }
      setTimeout(()=>{
        this.get_color()
      },1000)
      
    },
  }
</script>

<style scoped>
  .test_box {
    width: 100%;
    height: 1000px;
  }

  .test_dialog {
    position: fixed;
    width: 400px;
    height: 400px;
    background: #e3e3e3;
    top: 100px;
    left: 100px;
  }
  .btns li{
        display:inline-block;
        width: 30px;
        height: 30px;
        margin-right: 10px;
    }


</style>



// WEBPACK FOOTER //
// src/test/test.vue